import { Suspense, lazy } from 'react';
import { motion } from 'motion/react';
import { Nav } from './components/Nav';
import { useHashRoute } from './hooks/useHashRoute';
import Home from './pages/Home';

const Learn = lazy(() => import('./pages/Learn'));
const Playground = lazy(() => import('./pages/Playground'));

export default function App() {
  const route = useHashRoute();

  // 页面切换只做入场动画，不等退场（AnimatePresence mode="wait" 的退场依赖 rAF，
  // 在后台标签页会被暂停导致路由永久卡住——深链/后台打开场景踩过坑）。
  return (
    <>
      <Nav active={route.page} />
      <motion.main
        key={route.page}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.32, ease: 'easeOut' }}
      >
        <Suspense fallback={<PageLoading />}>
          {route.page === 'learn' ? (
            <Learn deepLink={route.rest} />
          ) : route.page === 'play' ? (
            <Playground />
          ) : (
            <Home />
          )}
        </Suspense>
      </motion.main>
    </>
  );
}

function PageLoading() {
  return (
    <div className="flex h-[70vh] items-center justify-center">
      <div className="glass flex items-center gap-3 px-6 py-4">
        <span
          className="inline-block h-4 w-4 animate-spin rounded-[4px]"
          style={{
            background: 'conic-gradient(from 0deg, #00e5ff, #007aff, transparent 70%)',
          }}
        />
        <span className="text-[13.5px] text-white/55">加载中…</span>
      </div>
    </div>
  );
}
